export enum ActionTypes {
    LOGIN_REQUEST = 'LOGIN_REQUEST',
    LOGIN_SUCCESS = 'LOGIN_SUCCESS',
    LOGIN_FAILURE = 'LOGIN_FAILURE',
    ADD_INFO = 'ADD_INFO',
    PROCESS_INFO = 'PROCESS_INFO',
    NAVIGATE_ROOT = 'NAVIGATE_ROOT',
    LOGOUT = 'LOGOUT',
    LOGOUT_SUCCESS = 'LOGOUT_SUCCESS',
    HELLO_WORLD = 'HELLO_WORLD',

    TABLE_REQUEST = 'TABLE_REQUEST',
    TABLE_META_SUCCESS = 'TABLE_META_SUCCESS',
    TABLE_SUCCESS = 'TABLE_SUCCESS',
    TABLE_FAILURE = 'TABLE_FAILURE',
    CLEAR_TABLE_ERROR = 'CLEAR_TABLE_ERROR',
    CLEAR_TABLE_DATA = 'CLEAR_TABLE_DATA',
    POPULATE_RELATION_FIELDS = 'POPULATE_RELATION_FIELDS',
    TABLE_SET_SORTING = 'TABLE_SET_SORTING',

    EDIT_COMPONENT_START = 'EDIT_COMPONENT_START',
    EDIT_COMPONENT_VALUE_UPDATED = 'EDIT_COMPONENT_VALUE_UPDATED',
    EDIT_COMPONENT_FIELD_UPDATED = 'EDIT_COMPONENT_FIELD_UPDATED',
    EDIT_COMPONENT_FIELD_NEW = 'EDIT_COMPONENT_FIELD_NEW',
    EDIT_COMPONENT_FIELD_DELETE = 'EDIT_COMPONENT_FIELD_DELETE',
    EDIT_COMPONENT_UPDATE_STATE = 'EDIT_COMPONENT_UPDATE_STATE',
    EDIT_COMPONENT_NEW = 'EDIT_COMPONENT_NEW',
    EDIT_COMPONENT_RESET = 'EDIT_COMPONENT_RESET',
    COMPONENT_DELETE = 'COMPONENT_DELETE',

    EDIT_ITEM_START = 'EDIT_ITEM_START',
    EDIT_ITEM_UPDATED = 'EDIT_ITEM_UPDATED',
    EDIT_ITEM_NEW = 'EDIT_ITEM_NEW',
    EDIT_ITEM_UPLOAD = 'EDIT_ITEM_UPLOAD',
    EDIT_ITEM_RESET_CURRENT = 'EDIT_ITEM_RESET_CURRENT',
    STORE_UPDATED = 'STORE_UPDATED',
    STORE_UPDATED_SUCCESS = 'STORE_UPDATED_SUCCESS',
    EDIT_ITEM_UPDATE_AND_STORE = 'EDIT_ITEM_UPDATE_AND_STORE',

    DELETE_ITEM = 'DELETE_ITEM',
    DELETE_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS',
    DELETE_ITEM_ERROR = 'DELETE_ITEM_ERROR',

    DELETE_ITEMS_BULK = 'DELETE_ITEMS_BULK',
    DELETE_ITEMS_BULK_SUCCESS = 'DELETE_ITEMS_BULK_SUCCESS',
    DELETE_ITEMS_BULK_ERROR = 'DELETE_ITEMS_BULK_ERROR',

    PATCH_TABLE_ITEMS_ARCHIVED = 'PATCH_TABLE_ITEMS_ARCHIVED',

    UI_UPDATE_MENU_INDEX = 'UI_UPDATE_MENU_INDEX',
    UI_TOGGLE_DEBUG = 'UI_TOGGLE_DEBUG',
    UI_TOGGLE_DARK_MODE = 'UI_TOGGLE_DARK_MODE',
    UI_SET_DARK_MODE = 'UI_SET_DARK_MODE',
    /** Bumps nonce so views (e.g. Home submissions) refetch alongside COMPONENTS_REQUEST */
    UI_RELOAD_CONFIG = 'UI_RELOAD_CONFIG',

    COMPONENTS_SUCCESS = "COMPONENTS_SUCCESS",
    COMPONENTS_FAILURE = "COMPONENTS_FAILURE",
    COMPONENTS_REQUEST = "COMPONENTS_REQUEST",
    COMPONENT_UPDATED_IN_LIST = "COMPONENT_UPDATED_IN_LIST",
    EDIT_COMPONENT_SET_META = "EDIT_COMPONENT_SET_META",

    FILE_NEW_WITH_RELATION = "FILE_NEW_WITH_RELATION",
    FILE_DELETE = "FILE_DELETE",

    QUICK_ADD_UPDATE = "QUICK_ADD_UPDATE",
    QUICK_ADD_UPDATE_SUCCESS = "QUICK_ADD_UPDATE_SUCCESS",
}


export const loginRequest = (email: string) => ({
    type: ActionTypes.LOGIN_REQUEST,
    payload: { email }
});

export const loginSuccess = (data: any) => ({
    type: ActionTypes.LOGIN_SUCCESS,
    payload: data,
});

export const componentUpdatedInList = (component: any) => ({
    type: ActionTypes.COMPONENT_UPDATED_IN_LIST,
    payload: component,
});

export const toggleDarkMode = () => ({
    type: ActionTypes.UI_TOGGLE_DARK_MODE,
});

export const setDarkMode = (enabled: boolean) => ({
    type: ActionTypes.UI_SET_DARK_MODE,
    payload: enabled,
});